import React from 'react'

type GridViewIconProps = {
  active: boolean
}

const GridViewIcon: React.FC<GridViewIconProps> = ({ active }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="8.46153" height="8.46153" rx="2" fill={active ? '#2D60FF' : '#5B73A0'} />
      <rect
        y="11.5385"
        width="8.46153"
        height="8.46153"
        rx="2"
        fill={active ? '#2D60FF' : '#5B73A0'}
      />
      <rect
        x="11.5385"
        y="11.5385"
        width="8.46153"
        height="8.46153"
        rx="2"
        fill={active ? '#2D60FF' : '#5B73A0'}
      />
      <rect
        x="11.5385"
        width="8.46153"
        height="8.46153"
        rx="2"
        fill={active ? '#2D60FF' : '#5B73A0'}
      />
    </svg>
  )
}
export default GridViewIcon
